import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { paymentGateway, paymentGatewayTitles, settings, settingsTitles } from "./enums";
/**
 * Settings class
 */

export class Settings extends BaseModel {
  constructor(...args) {
    super(...args);

    this.primary = () => 'name';

    this.getId = () => {
      return this.model.name;
    };

    this.getName = () => {
      return this.model.name;
    };

    this.getTitle = () => {
      return this.model.title;
    };

    this.getCurrentValue = () => {
      return this.model.value;
    };

    this.getCreatedAt = () => {
      return this.model.createdAt;
    };

    this.getUpdatedAt = () => {
      return this.model.updatedAt;
    };

    this.isEnableIosAndroidPay = () => {
      return Boolean(Number(this.model.enableIosAndroidPay));
    };

    this.getPaymentGateway = (asLabel = false) => {
      return asLabel ? Settings.paymentGatewayTitles[this.model.paymentGateway || 'unknown'] || Settings.paymentGatewayTitles.unknown : this.model.paymentGateway;
    };

    this.getValue = name => {
      return this.model[name];
    };

    this.getSettingTitle = name => {
      return Settings.settingsTitles[name] || 'Unknown';
    };
  }

  /**
   * Create settings
   *
   * @param {object} object
   *
   * @return {Settings}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * @inheritDoc
   */


  primaryKey() {
    return this.getId();
  }
  /**
   * @inheritDoc
   */


}
Settings.paymentGateway = paymentGateway;
Settings.paymentGatewayTitles = paymentGatewayTitles;
Settings.settings = settings;
Settings.settingsTitles = settingsTitles;